// docs/35 — the encounter's creatures as the server keeps them: `wildlife` rows for the open
// encounter (wired in core/encounter/session.ts), or the gallery's wasm preview. A plain map, not a
// store: the scene reads it every frame and nothing renders from it in React.
import { rowOf, type WildRow } from './motion';

const rows = new Map<number, WildRow>();
let version = 0;

type SdkRow = Parameters<typeof rowOf>[0];

export const wildFeed = {
  put(r: SdkRow): void { const w = rowOf(r); rows.set(w.id, w); version++; },
  drop(id: bigint | number): void { if (rows.delete(Number(id))) version++; },
  /** Replace everything (the gallery preview). */
  set(list: readonly WildRow[]): void { rows.clear(); for (const r of list) rows.set(r.id, r); version++; },
  clear(): void { if (rows.size) { rows.clear(); version++; } },
  rows(): IterableIterator<WildRow> { return rows.values(); },
  get size(): number { return rows.size; },
  get version(): number { return version; },
};
